var angular      = require('angular');
var _module      = require('./index');
imagesLoaded = require('imagesloaded');

require('angular-animate');
require('angular-images-loaded');
require('../lr-touch');
require('../cached-templates/templates');

_module.requires.push('lr.touch', 'ngAnimate', 'angular-images-loaded', 'templates');

_module.directive('fullscreenImage', [
    '$rootScope',
    '$compile',
    '$templateCache',

    function($rootScope, $compile, $templateCache) {
        var IMAGE_LOADING_EVENT          = 'fullscreenImage:imageLoading';
        var IMAGE_LOADING_COMPLETE_EVENT = 'fullscreenImage:imageLoadingComplete';
        var TEMPLATE                     = $templateCache.get('js/components/core/templates/fullscreen-image.tmpl.html');

        return {
            restrict: 'AE',
            scope: {
                '$image': '=image'
            },
            link: function($scope, elem, attrs) {
                var html = $compile(TEMPLATE)($scope);

                $scope.maxWidth   = $(window).width();
                $scope.maxHeight  = $(window).height();
                $scope.$showImage = false;
                $scope.imgLoadedEvents = {
                    done: function() {
                        $scope.$showImage = true;
                        $rootScope.$broadcast(IMAGE_LOADING_COMPLETE_EVENT);
                    }
                };

                $(html).css('display', 'none');
                $('body').append(html);

                $(window).on('resize', function() {
                    $scope.$apply(function() {
                        $scope.maxWidth  = $(window).width();
                        $scope.maxHeight = $(window).height();
                    });
                });

                $scope.$close = function() {
                    $scope.$image = null;
                };

                $scope.$watch('$image', function(newValue) {
                    if(newValue) {
                        $(html).css('display', 'block');
                        $rootScope.$broadcast(IMAGE_LOADING_EVENT);
                    } else {
                        $scope.$showImage = false;
                    }
                });
            }
        };
    }
]);
